export function buildFormControllClass(
  className,
  hidden,
  required,
  isValid,
  disable
) {
  let classString = className ? ` ${className}` : ""

  if (hidden) classString += " form-control--hidden"
  if (required) classString += " form-control--required"
  if (disable) classString += " form-control--disabled"
  if (isValid === false) classString += " form-control--error"

  return classString
}
